/* @flow */

import * as namespaces from './appNewTopicActionNamespaces';
import * as types from './appNewTopicActionTypes';
import { fetchKeywords } from 'src/shared/domain/keyword/action/keywordActions';
import { queueNotification } from 'src/shared/app/notification/action/uiNotificationActions';

import { convertEngagementTriggerToNotification } from 'src/shared/app/topic/new/util/newTopicUtil';

export function setNewTopicReady() {
  return {
    type: types.SET_NEW_TOPIC_READY,
  };
}

export function unsetNewTopicReady() {
  return {
    type: types.UNSET_NEW_TOPIC_READY,
  };
}

/*
 |------------------------------------------------------------------------------
 | Keywords
 |------------------------------------------------------------------------------
 */

export function fetchNewTopicKeywords(eventId: number, options?: Object = {}) {
  return fetchKeywords(
    eventId,
    { ...options, ordering: '-interests_count', topics_count: 0 },
    namespaces.NEW_TOPIC_KEYWORDS,
  );
}

export function fetchNewTopicRecommendedKeywords(
  eventId: number,
  options?: Object = {},
) {
  return fetchKeywords(
    eventId,
    { ...options, ordering: '-interests_count', topics_count: 0 },
    namespaces.NEW_TOPIC_RECOMMENDED_KEYWORDS,
  );
}

/*
 |------------------------------------------------------------------------------
 | Notifications
 |------------------------------------------------------------------------------
 */

export function showEngagementModal(data: string) {
  return queueNotification(convertEngagementTriggerToNotification(data));
}
